import React from 'react'
import Signup from '../../../features/auth/components/Signup'

function SignupPage() {
  return (
    <div>
      <Signup />
    </div>
  )
}

export default SignupPage
